import { Action, isActionOfType } from '../types';
import initialState from './initialState';
import type { SongsStore } from './types';
import {
  getSongsSuccess,
  getSongSuccess,
  resetSongs,
  setSongListPosition,
} from './actions';
import type { SongsActionTypes } from './actions';

const reducer = (
  state: SongsStore = initialState,
  action: Action<SongsActionTypes>
): SongsStore => {
  if (isActionOfType(action, getSongSuccess)) {
    const { song } = action.payload;

    return {
      ...state,
      songs: {
        ...state.songs,
        [song.id]: song,
      },
    };
  }

  if (isActionOfType(action, getSongsSuccess)) {
    const { songs, paginationData } = action.payload;

    if (Object.keys(songs).length === 0) return state;

    return {
      ...state,
      page: paginationData.currentPage,

      songs: {
        ...state.songs,
        ...songs,
      },
      ids: [...state.ids, ...Object.keys(songs)],
    };
  }

  if (isActionOfType(action, resetSongs)) {
    return {
      ...initialState,
      pendingForLibrary: state.pendingForLibrary,
    };
  }

  if (isActionOfType(action, setSongListPosition)) {
    const { position } = action.payload;
    return {
      ...state,
      songListPosition: position,
    };
  }

  return state;
};

export default reducer;
